"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _propTypes = require("prop-types");
var _socialShare = require("@kyruus/social-share");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _styles = require("./styles");
var _Tracking = require("../../lib/constants/Tracking");
const proptypes = {
  track: _propTypes.func.isRequired,
  /**
   * Injected by `injectIntl HOC`
   */
  intl: (0, _propTypes.shape)({
    locale: _propTypes.string.isRequired,
    formatMessage: _propTypes.func.isRequired
  }).isRequired
};
const PrintButton = _ref => {
  let {
    intl,
    track
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.PrintButtonContainer, null, /*#__PURE__*/_react.default.createElement(_socialShare.PrintButton, {
    onBeforeClick: () => {
      track(_Tracking.userEvents.PRINT);
    },
    showLabel: true,
    label: intl.formatMessage(_messages.default.printButtonText)
  }));
};
PrintButton.propTypes = proptypes;
var _default = exports.default = (0, _intl.injectIntl)(PrintButton);
PrintButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PrintButton",
  "props": {
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "intl": {
      "description": "Injected by `injectIntl HOC`",
      "type": {
        "name": "shape",
        "value": {
          "locale": {
            "name": "string",
            "required": true
          },
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};